export interface NewsItem {
  id: string;
  title: string;
  date: string;
  summary: string;
  tag: string;
  relatedFilm?: string;
  relatedActor?: string;
}

export const news: NewsItem[] = [
  {
    id: "n1",
    title: "《风声再起》票房口碑双丰收，谍战题材重回观众视野",
    date: "2026-10-08",
    summary:
      "上映首周即斩获多项票房纪录，影片对人物心理的细腻刻画获得观众一致好评，多位影评人称其为近年来最扎实的谍战片之一。",
    tag: "票房",
    relatedFilm: "f10",
  },
  {
    id: "n2",
    title: "《少年游》官宣定档，顾星辰再演少年剑客",
    date: "2026-10-06",
    summary:
      "制作方公布首支预告片，水墨风格的画面与凌厉的武打设计引发热议。顾星辰表示为此角色进行了三个月的剑术特训。",
    tag: "定档",
    relatedFilm: "f13",
  },
  {
    id: "n3",
    title: "林知遥凭《长夜将明》提名年度最佳女主角",
    date: "2026-10-04",
    summary:
      "评委会评价她在片中“将脆弱与坚韧同时写进一个眼神里”。这是她继《风声再起》之后再度获得重要奖项提名。",
    tag: "奖项",
    relatedActor: "a1",
  },
  {
    id: "n4",
    title: "沈亦舟新片《山与海之间》发布首款海报",
    date: "2026-10-02",
    summary:
      "海报以山海交界的黄昏为背景，一冷一暖的色调暗示剧中人物的情感张力，网友直呼“氛围感拉满”。",
    tag: "物料",
    relatedActor: "a2",
  },
  {
    id: "n5",
    title: "科幻巨制《星轨之外》确认引进，年底登陆内地银幕",
    date: "2026-09-29",
    summary:
      "影片汇聚艾米莉·卡特与沈亦舟的中西合璧阵容，视觉特效由国际顶级团队操刀，被列为年度最受期待影片。",
    tag: "引进",
    relatedFilm: "f6",
  },
  {
    id: "n6",
    title: "金志勋回应《刃》续集传闻：如果剧本够好，随时待命",
    date: "2026-09-26",
    summary:
      "在最新采访中，金志勋谈及角色时说，动作之外更打动他的是人物背负的孤独。续集能否开拍仍取决于剧本打磨进度。",
    tag: "专访",
    relatedActor: "a6",
  },
  {
    id: "n7",
    title: "《回到1999》收官，怀旧话题登上热搜榜前列",
    date: "2026-09-23",
    summary:
      "剧集以温柔的方式讲述成长，结尾的开放式处理引发大量讨论，相关话题累计阅读量突破数亿。",
    tag: "热播",
    relatedFilm: "f7",
  },
  {
    id: "n8",
    title: "高桥美纪加盟《午夜书店》第二季，角色线索首次曝光",
    date: "2026-09-20",
    summary:
      "制作方透露新一季将延续治愈基调，并加入更多关于记忆与选择的思辨，高桥美纪饰演的角色成为关键引线。",
    tag: "剧集",
    relatedActor: "a5",
  },
  {
    id: "n9",
    title: "《雾港迷航》重映加长版定档，陆沉苏晚晴对手戏成最大看点",
    date: "2026-09-17",
    summary:
      "加长版新增约二十分钟叙事内容，补完了影片中两条未展开的支线，被影迷称为“终于圆满的遗憾”。",
    tag: "重映",
    relatedFilm: "f2",
  },
  {
    id: "n10",
    title: "综艺《巅峰对决》官宣第三季赛制升级",
    date: "2026-09-14",
    summary:
      "新一季引入团队协作与个人挑战并行的双线赛制，节目组表示希望在竞技之外展现更多真实的成长瞬间。",
    tag: "综艺",
    relatedFilm: "f15",
  },
  {
    id: "n11",
    title: "苏晚晴成立个人工作室，首部制片作品聚焦女性题材",
    date: "2026-09-11",
    summary:
      "从演员到制片人的身份转变，她表示希望讲述更多“被忽略的普通女性的故事”，项目已进入剧本打磨阶段。",
    tag: "动态",
    relatedActor: "a3",
  },
  {
    id: "n12",
    title: "艾米莉·卡特谈《深海回声》：最难的是与孤独相处",
    date: "2026-09-08",
    summary:
      "在片中饰演海底工程师的她分享，为还原真实状态曾在模拟舱内完成多日拍摄，这段经历让她重新理解“回家”的意义。",
    tag: "专访",
    relatedActor: "a10",
  },
];